module.exports = __webpack_public_path__ + "img/newicon7click.a31a7b82.svg";